import * as angular from 'angular';
import * as _ from 'underscore';
import { IPagination } from '../../../../../app.common/modules/common/models';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { ClassificationCategoriesService } from '../../../../../app.retailer.common/modules/categories/classification-categories.service';
import { AccountService } from '../../../account/account.service';
import { StoreInventoryListItem, StoreInventoryResponse } from '../../../core';
import { InventoryService } from '../../../inventory/inventory.service';

interface IPaginationShopInventory extends IPagination {
    data: StoreInventoryListItem[];
    filter: string;
    setData: () => void;
    applyFilter: () => StoreInventoryListItem[];
}

export class ShopInventoryController {
    public static $inject = ['$scope', 'inventoryService', 'notificationService', '$translate', 'accountService', 'classificationCategoriesService'];
    public waiting: boolean = false;
    public data: StoreInventoryResponse & { inventory?: boolean };
    public htmlTooltip: {} = {
        awaitingApproval: this.$translate.instant('this_brand_is_awaiting_approval'),
        rejected: 'This brand was rejected'
    };

    public pagination: IPaginationShopInventory = {
        data: [],
        page: 1,
        pageSize: 10,
        total: 0,
        filter: '',
        setData: () => {
            const filtered = this.pagination.applyFilter();
            this.pagination.total = _.size(filtered);
            this.pagination.data = filtered.slice(this.pagination.pageSize * (this.pagination.page - 1), this.pagination.pageSize * this.pagination.page);
            while (this.pagination.total > 0 && _.size(this.pagination.data) === 0) {
                this.pagination.page--;
                this.pagination.data = filtered.slice(this.pagination.pageSize * (this.pagination.page - 1), this.pagination.pageSize * this.pagination.page);
            }
        },
        applyFilter: () => {

            const keyword = this.pagination.filter.trim();
            const regex = new RegExp('\\b' + keyword + '.*', 'i');
            if (this.pagination.filter.trim()) {
                return _.filter(this.data.ClassificationCategories, (category: StoreInventoryListItem) => {
                    return regex.test(category.CategoryFullName);
                });
            } else {
                return this.data.ClassificationCategories;
            }
        }
    };
    public shopID: number = null;
    constructor(
        private $scope: ng.IScope,
        private inventoryService: InventoryService,
        private notificationService: NotificationService,
        private $translate: angular.translate.ITranslateService,
        private accountService: AccountService,
        private classificationCategoriesService: ClassificationCategoriesService
    ) { }

    public $onChanges(changes: any) {
        if (changes.shopId && changes.shopId.isFirstChange()) {
            this.shopID = changes.shopId.currentValue;
            this.getInventory(this.shopID);
            this.loadCategories();
        }
    }

    private getInventory = async (shopID: number) => {
        this.waiting = true;
        try {
            const response = await this.inventoryService.get(shopID);
            if (response === 'cancel') {
                return;
            }
            this.data = response;
            this.data.inventory = this.data.ClassificationCategories && !_.isEmpty(this.data.ClassificationCategories);

            this.$scope.$watchGroup(['$ctrl.pagination.page', '$ctrl.pagination.filter'], (value, oldValue) => {
                if (value) {
                    this.pagination.setData();
                }
            });
        } catch (error) {
            this.notificationService.showErrorMessage(error ? error : null);
        }
        this.waiting = false;
    }

    private async loadCategories() {
        const id = this.accountService.userData.languageID;
        await this.classificationCategoriesService.getTree(id);
    }
}

angular.module('naut').component('shopInventory', {
    template: require('./shopInventory.html'),
    controller: ShopInventoryController,
    controllerAs: '$ctrl',
    bindings: {
        shopId: '<',
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/places/components/shopInventory/shopInventory.component.ts